// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"efbb7410","171":"48468565","207":"1b6f55f5","244":"9204a534","293":"ccd2f4c4","308":"77de803f","347":"ec97146b","396":"4b390de1","710":"970970de","867":"078e7815","982":"a0b4d678"}[chunkId] + ".chunk.js";
};